import React, { useEffect, useRef } from "react";

const HUBSPOT_EMBED_URL =
  "https://meetings-na2.hubspot.com/milad-ghods?embed=true";
const HUBSPOT_SCRIPT_URL =
  "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";

export default function BookDemoModal({ onClose }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const existing = document.querySelector(
      `script[src="${HUBSPOT_SCRIPT_URL}"]`
    );
    if (!existing) {
      const script = document.createElement("script");
      script.src = HUBSPOT_SCRIPT_URL;
      script.async = true;
      document.body.appendChild(script);
    } else {
      if (window.hbspt?.meetings?.create) {
        window.hbspt.meetings.create(
          containerRef.current.querySelector(".meetings-iframe-container")
        );
      }
    }
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative w-full max-w-3xl mx-4 bg-white rounded-2xl border border-gray-200 overflow-hidden max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <div>
            <h2 className="text-lg font-bold text-gray-900">Book a Demo</h2>
            <p className="text-sm text-gray-500">
              Pick a time that works for you
            </p>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
          >
            <svg
              className="w-4 h-4 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* HubSpot embed */}
        <div
          ref={containerRef}
          className="flex-1 overflow-y-auto p-6"
          style={{ minHeight: 550 }}
        >
          <div
            className="meetings-iframe-container"
            data-src={HUBSPOT_EMBED_URL}
          />
        </div>
      </div>
    </div>
  );
}
